import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Image from "components/image";

// Images
import magicTime2 from "img/diamonds/IMAG0033.jpg";
import collectionMeta from "content/collections/diamond-python.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const DiamondPython = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Diamond Pythons (Morelia spilota spilota)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/diamond-python" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        I have two diamond pythons currently but I feel like I could own 20 and
        still want more. I cool them every winter for 3 months at about 50-55 F
        during the night and then I bring them into the snake room during the
        day and put them on the floor which is in the low 70's F. At night I
        return them to the cold room. Hoping to breed these in 2025. Check back 
        later in 2025 to see if I have any diamond pythons for sale. They will be
        on my <a href={"https://www.gcreptiles.com/available"} alt="Available">Available</a> page.
      </BodyText>

      <Image src={magicTime2} caption="2018, Magic Time" />

      <BodyText>
        I've made many mistakes as a herp keeper but by far my worst came with
        my first diamond python, Magic Time. I bought him from Psychotic Exotics
        and he was the most majestic animal I'd ever had. Everything was going
        well until about a year later when I brought in several new animals and
        didn't quarantine them for long enough. I found out too late that they
        came in with mites. I treated my whole collection several times and I
        believe I didn't wait long enough for the Provent a Mite mist to settle
        before putting Magic Time back in his cage. The next day he was dead, as
        well as a beautiful Jungle Carpet python in another cage. I still kick
        myself over this and have a lump in my stomach thinking about both of
        them.
      </BodyText>

      <PageGallery slug="diamond-python" maxWidth="900" />
    </ContentBox>
  );
};

export default DiamondPython;
